export default "__VITE_ASSET__YQvrgZJU__"